"use client";

import TicketShowCase from "@/components/TicketShowcase";
import { mapRouteToFlightCard } from "@/utils/flightCardMapper";

export default function ContinentTicketShowCaseClient({
  title,
  cheapestRoutes,
  currency,
  formattedContinent,
}) {
  const oneWayFlights = (
    cheapestRoutes?.CheapestOWFlightsFromOrigin || []
  ).map(mapRouteToFlightCard);
  const roundTripFlights = (
    cheapestRoutes?.CheapestRTFlightsFromOrigin || []
  ).map(mapRouteToFlightCard);

  return (
    <TicketShowCase
      title={title}
      items={cheapestRoutes}
      componentType="FlightTicketsTab"
      componentProps={{
        tabItems: {
          1: oneWayFlights,
          2: roundTripFlights,
        },
      }}
      showTabs={true}
    />
  );
}
